import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const BillMiniIcon = ({
  width = 22,
  marginRight,
  color = 'black',
  marginLeft,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 25">
      <g fill="none" fillRule="evenodd">
        <path
          fill={getSemanticTextColor(color)}
          d="M8.772 19.256c.219-.021.38.07.52.205.29.279.298.743.019 1.032l-.537.556h6.06c.404 0 .732.328.732.73 0 .403-.328.73-.731.73H8.774l.537.556c.279.29.27.754-.02 1.033-.136.132-.316.205-.506.205-.197 0-.388-.081-.526-.223l-2.22-2.301 2.22-2.3c.136-.14.318-.22.513-.223zM22 6.953v11.089H0V6.952h22zM11 9.079c-1.917 0-3.469 1.553-3.469 3.469s1.552 3.469 3.47 3.469c1.915 0 3.468-1.553 3.468-3.47 0-1.915-1.553-3.468-3.469-3.468zM13.132.678c.194.004.377.083.513.223l2.22 2.3-2.22 2.3c-.138.143-.33.224-.527.224-.19 0-.37-.073-.507-.205-.14-.136-.22-.317-.223-.513-.004-.195.07-.38.204-.52l.537-.555H7.07c-.404 0-.73-.328-.73-.73 0-.403.326-.731.73-.731h6.06l-.537-.555c-.135-.14-.208-.325-.204-.52.004-.195.082-.377.223-.513.141-.136.333-.188.52-.205z"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
